import { Alert as IAlert } from 'src/interfaces/dialog';

import styles from './Alert.module.scss';
import Button from '../Button';

interface Props extends IAlert {
  onClose?: () => void;
}

const Alert = (props: Props) => {
  const { title, message, onClose, callback } = props;
  const handleClick = () => {
    callback?.();
    onClose?.();
  };
  return (
    <div className={styles.alert}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.message}>{message}</div>
      <div className={styles.buttons}>
        <Button buttonType="button" type="primary" onClick={handleClick}>
          OK
        </Button>
      </div>
    </div>
  );
};

export default Alert;
